<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="atlas">
			<v-card-title>
				<span>Dalintis atlasu</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<p>Pasirinkę dalijimosi tipą "Pasidalinta su", galite nurodyti, su kuriais portalo naudotojais norite dalintis atlasu. Įveskite naudotojo vardą ir spauskite ženklelį "Pridėti". Dalindamiesi galite suteikti kitam asmeniui teises peržiūrėti arba redaguoti atlasą. Pasirinkus dalijimosi tipą "Viešas", atlasą galės matyti visi geoportal.lt naudotojai, kurie turės jo interneto nuorodą (matoma nuorodos lauke lango viršuje). Dalijimosi tipas "Privatus" reiškia, kad prie atlaso prieigą turite tik Jūs.</p>
					<v-select
						label="Dalinimosi tipas"
						hide-details
						v-model="sharingType"
						filled
						class="body-2 mt-2"
						:rules="[v => !!v || 'Laukas privalomas']"
						:items="sharingTypeItems"
						item-value="key"
						item-text="name"
						placeholder="Pasirinkite dalinimosi tipo reikšmę"
						:loading="shareInAction"
						ref="sharingType"
					></v-select>
					<template v-if="sharingType == 'privateShare' && !shareInAction">
						<div class="mt-4">
							<v-container align-center class="d-flex" pa-0>
								<v-text-field
									placeholder="Vartotojo vardas"
									single-line
									dense
									hide-details
									v-model="userNameToShareWith"
									@keydown.enter="addUserNameToShareWith"
									:loading="userNameToShareWithLoading"
									:error="userNameToShareWithError"
								></v-text-field>
								<v-btn
									icon
									v-on:click="addUserNameToShareWith"
									:disabled="userNameToShareWithLoading"
								>
									<v-icon
										title="Pridėti"
									>mdi-account-plus</v-icon>
								</v-btn>
							</v-container>
							<template v-if="usersListLoading">
								<v-progress-circular
									indeterminate
									color="primary"
									:size="20"
									width="2"
									class="mt-5"
								></v-progress-circular>
							</template>
							<template v-else>
								<div v-if="sharedWith && sharedWith.length">
									<table class="mt-5">
										<template v-for="(user, i) in sharedWith">
											<AtlasSharingUserRow
												:user="user"
												:removeUserFromUsersList="removeUserFromUsersList"
												:atlasId="atlas['atlasID']"
												:atlasTitle="atlas['title']"
												:key="i"
											/>
										</template>
									</table>
								</div>
							</template>
						</div>
					</template>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="shareInAction"
				>
					Uždaryti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";
	import AtlasSharingUserRow from "./AtlasSharingUserRow";

	export default {
		data: function(){
			var data = {
				dialog: false,
				shareInAction: false,
				sharingTypeItems: AtlasHelper.getSharingTypeItems(),
				sharingType: null,
				atlas: null,
				userNameToShareWith: null,
				userNameToShareWithLoading: null,
				userNameToShareWithError: null,
				sharedWith: null,
				usersListLoading: false
			};
			return data;
		},
		created: function(){
			this.$vBus.$on("show-atlas-sharing-form", this.showForm);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-atlas-sharing-form", this.showForm);
		},
		components: {
			AtlasSharingUserRow
		},
		methods: {
			closeDialog: function(){
				this.atlas = null;
				this.dialog = false;
			},
			share: function(){
				if (this.$refs.form) {
					var formValid = this.$refs.form.validate();
					if (formValid) {
						this.shareInAction = true;
						var def = AtlasHelper.changeAtlasSharingType(this.atlas["atlasID"], this.sharingType);
						def.then(function(){
							this.shareInAction = false;
							this.atlas["shareType"] = this.sharingType; // Aktualu, kad sąraše esančio komponento duomenys būtų irgi pasikeitę! Neaišku ar gerai taip tiesiog pakeisti reikšmę, ar geriau būtų atnaujinti visą komponentą darant užklausą į serverį...
							this.$refs.sharingType.blur();
						}.bind(this), function(){
							this.$vBus.$emit("show-message", "error");
							this.shareInAction = false;
							this.$refs.sharingType.blur();
							// TODO!!! Ką daryti? Atstatyti ankstesnę reikšmę???
						}.bind(this));
					}
				}
			},
			showForm: function(atlas){
				this.sharingType = atlas["shareType"];
				this.userNameToShareWith = this.userNameToShareWithError = this.userNameToShareWithLoading = null;
				this.atlas = atlas;
				this.dialog = true;
				this.getAtlasUsersList();
			},
			addUserNameToShareWith: function(){
				if (this.userNameToShareWith) {
					this.userNameToShareWithLoading = true;
					this.userNameToShareWithError = false;
					var role = "reader";
					var def = AtlasHelper.shareAtlasWith(this.atlas["atlasID"], this.userNameToShareWith, role, this.atlas["title"]);
					def.then(function(){
						this.userNameToShareWithLoading = false;
						this.userNameToShareWith = null;
						this.getAtlasUsersList();
					}.bind(this), function(rejectionReason){
						var message = "error";
						if (rejectionReason == "user-doesnt-exist") {
							message = "Vartotojas nurodytu vardu neegzistuoja!";
						}
						this.$vBus.$emit("show-message", message);
						this.userNameToShareWithLoading = false;
					}.bind(this));
				} else {
					this.userNameToShareWithError = true;
				}
			},
			getAtlasUsersList: function(){
				this.usersListLoading = true;
				var def = AtlasHelper.getAtlasUsersList(this.atlas["atlasID"]);
				def.then(function(usersList){
					var sharedWith = [];
					usersList.forEach(function(user){
						if (user.userRole != "owner") {
							sharedWith.push(user);
						}
					});
					this.sharedWith = sharedWith;
					this.usersListLoading = false;
				}.bind(this), function(){
					this.usersListLoading = false;
				}.bind(this));
			},
			removeUserFromUsersList: function(user, callback){
				var def = AtlasHelper.removeUserFromUsersList(this.atlas["atlasID"], user, this.atlas["title"]);
				def.then(function(){
					if (callback) {
						callback();
					}
					this.getAtlasUsersList();
				}.bind(this), function(){
					if (callback) {
						callback();
					}
					this.$vBus.$emit("show-message", "error");
				}.bind(this));
			}
		},
		watch: {
			sharingType: {
				handler: function(newValue, oldValue){
					if (oldValue) {
						this.share();
					}
				}
			}
		}
	}
</script>

<style scoped>
	table {
		border-collapse: collapse;
	}
</style>